import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import {
  Code,
  Users,
  Globe,
  Award
} from 'lucide-react';

const Careers = () => {
  const companyCulture = [
    {
      title: 'Innovation First',
      description: 'We encourage creative problem-solving and cutting-edge research',
      icon: Code
    },
    {
      title: 'Collaborative Environment',
      description: 'Teamwork and knowledge sharing are at our core',
      icon: Users
    },
    {
      title: 'Global Perspective',
      description: 'We value diversity and global insights',
      icon: Globe
    },
    {
      title: 'Continuous Learning',
      description: 'Ongoing education and professional growth',
      icon: Award
    }
  ];

  return (
    <div className="min-h-screen bg-background py-16">
      <div className="container mx-auto px-4">
        {/* Hero Section */}
        <section className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Join <span className="text-primary">LLM Checks</span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Be part of a mission to make AI safer, more reliable, and more ethical
          </p>
        </section>

        {/* Company Culture */}
        <section className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Our Culture</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              We're building more than a product. We're creating a movement towards responsible AI.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {companyCulture.map((culture, index) => (
              <Card key={index} className="text-center border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <CardContent className="pt-6">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <culture.icon className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="font-semibold mb-2">{culture.title}</h3>
                  <p className="text-sm text-muted-foreground">{culture.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Careers;
